import i18n from '@/localization';

export const getErrorMessageForDataSourceMutation = ({ responseMessage, codes }: { responseMessage: string; codes: string[] }) => {
    if (codes.length > 0) {
        // For each code type we must show the message that matches with server_errors
        const messages = codes?.map((code) => {
            switch (code) {
                case 'csv_configuration_invalid_path':
                    return i18n.t('server_errors:csv_configuration_invalid_path');
                case 'csv_configuration_invalid_type':
                    return i18n.t('server_errors:csv_configuration_invalid_type');
                case 's3_configuration_invalid_bucket':
                    return i18n.t('server_errors:s3_configuration_invalid_bucket');
                case 's3_configuration_invalid_credentials':
                    return i18n.t('server_errors:s3_configuration_invalid_credentials');
                case 's3_configuration_invalid_region':
                    return i18n.t('server_errors:s3_configuration_invalid_region');
                case 'sftp_configuration_missing_host':
                    return i18n.t('server_errors:sftp_configuration_missing_host');
                case 'sftp_configuration_missing_username':
                    return i18n.t('server_errors:sftp_configuration_missing_username');
                case 'sftp_configuration_missing_password_or_key':
                    return i18n.t('server_errors:sftp_configuration_missing_password_or_key');
                case 'sftp_configuration_invalid_credentials':
                    return i18n.t('server_errors:sftp_configuration_invalid_credentials');
                case 'csv_configuration_missing_headers':
                    return i18n.t('server_errors:csv_configuration_missing_headers');
                case 'csv_configuration_invalid_headers_duplicates':
                    return i18n.t('server_errors:csv_configuration_invalid_headers_duplicates');
                case 'csv_configuration_invalid_headers_chars':
                    return i18n.t('server_errors:csv_configuration_invalid_headers_chars');
                case 'code_configuration_url_invalid':
                    return i18n.t('server_errors:code_configuration_url_invalid');
                default:
                    return i18n.t('ALL:errors');
            }
        });
        return messages?.join(', ');
    }
};
